import {
  StarFull_default
} from "./chunk-WGAKVF5P.jsx";
import {
  TailedArrow_default
} from "./chunk-DXVDNX64.jsx";
import {
  getIntlDate
} from "./chunk-RI3LNOUV.jsx";
import {
  LANGUAGE_SORT_ORDER
} from "./chunk-ZGFN6LHJ.jsx";
import {
  Image
} from "./chunk-UVV746MP.jsx";
import {
  hashCode,
  onEnterKeyPress
} from "./chunk-NZGIYA4E.jsx";
import {
  Conditional
} from "./chunk-AAE3RIHT.jsx";
import {
  titleCase
} from "./chunk-WCSQGGO5.jsx";
import {
  __name,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-DVUTYNGK.jsx";

// src/components/ReviewsSection/types.ts
var EReviewsSectionVariants = {
  Default: "default",
  PinnedReviews: "pinned-reviews",
  Modal: "modal"
};

// src/components/ReviewsSection/constants.ts
var FLAGS_FOLDER_URL = "https://cdn-imgix-open.headout.com/home/country-flags/4x3/";
var DEFAULT_REVIEWER_NAME = "headout guest";
var REVIEW_CONTENT_ACTIONS = {
  TRANSLATE_REVIEW: "Translate Review",
  VIEW_ORIGINAL: "View Original"
};

// src/components/ReviewsSection/utils.ts
import { token as token3 } from "@headout/pixie/tokens";

// src/assets/svgIcons/StarHalf.tsx
import { token } from "@headout/pixie/tokens";
var StarHalf = /* @__PURE__ */ __name((_a) => {
  var _b = _a, {
    strokeColor = "colors.semantic.icon.candy",
    size = 14
  } = _b, props = __objRest(_b, [
    "strokeColor",
    "size"
  ]);
  return <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    fill='none'
    viewBox={`0 0 ${size} ${size}`}
    {...props}
  >
		<path
    fill={token(strokeColor)}
    d='M7 .512V11.27l-4.024 2.218.768-4.694L.49 5.472l4.5-.69L7 .513z'
  />
		<path
    fill={token(strokeColor)}
    fillRule='evenodd'
    d='M7 0c.186 0 .356.11.438.285l1.898 4.03 4.246.65a.495.495 0 01.394.349.529.529 0 01-.124.524l-3.071 3.135.724 4.429a.523.523 0 01-.194.5.47.47 0 01-.514.04L7 11.848l-3.797 2.092a.47.47 0 01-.514-.039.523.523 0 01-.195-.5l.725-4.429L.148 5.838a.529.529 0 01-.124-.524.495.495 0 01.394-.349l4.245-.65 1.9-4.03A.487.487 0 017 0zm0 1.668L5.426 5.009a.49.49 0 01-.367.28l-3.521.54 2.547 2.599a.527.527 0 01.14.453l-.6 3.672 3.148-1.735a.469.469 0 01.454 0l3.149 1.735-.602-3.672a.527.527 0 01.141-.453l2.547-2.6-3.52-.54a.49.49 0 01-.368-.279L7 1.668z'
    clipRule='evenodd'
  />
	</svg>;
}, "StarHalf");
var StarHalf_default = StarHalf;

// src/assets/svgIcons/StarEmpty.tsx
import { token as token2 } from "@headout/pixie/tokens";
var StarEmpty = /* @__PURE__ */ __name((_a) => {
  var _b = _a, {
    strokeColor = "colors.semantic.icon.candy",
    size = 14
  } = _b, props = __objRest(_b, [
    "strokeColor",
    "size"
  ]);
  return <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    fill='none'
    viewBox={`0 0 ${size} ${size}`}
    {...props}
  >
		<path
    fill={token2(strokeColor)}
    fillRule='evenodd'
    d='M7 0c.186 0 .356.11.438.285l1.898 4.03 4.246.65a.495.495 0 01.394.349.529.529 0 01-.124.524l-3.071 3.135.724 4.429a.523.523 0 01-.194.5.47.47 0 01-.514.04L7 11.848l-3.797 2.092a.47.47 0 01-.514-.039.523.523 0 01-.195-.5l.725-4.429L.148 5.838a.529.529 0 01-.124-.524.495.495 0 01.394-.349l4.245-.65 1.9-4.03A.487.487 0 017 0zm0 1.668L5.426 5.009a.49.49 0 01-.367.28l-3.521.54 2.547 2.599a.527.527 0 01.14.453l-.6 3.672 3.148-1.735a.469.469 0 01.454 0l3.149 1.735-.602-3.672a.527.527 0 01.141-.453l2.547-2.6-3.52-.54a.49.49 0 01-.368-.279L7 1.668z'
    clipRule='evenodd'
  />
	</svg>;
}, "StarEmpty");
var StarEmpty_default = StarEmpty;

// src/components/ReviewsSection/utils.ts
var getContentLimit = /* @__PURE__ */ __name(({
  limitLines,
  hasTranslation,
  variant
}) => {
  if (variant === EReviewsSectionVariants.PinnedReviews) {
    return 4;
  }
  if (variant === EReviewsSectionVariants.Modal) {
    return void 0;
  }
  if (!limitLines) {
    return hasTranslation ? 10 : 11;
  }
  return hasTranslation ? 4 : 5;
}, "getContentLimit");
var getRandomReviewerImage = /* @__PURE__ */ __name((nonCustomerName = "") => {
  const userNameHash = hashCode(nonCustomerName);
  const totalAvatarVariants = 24;
  const avatarIndex = userNameHash % totalAvatarVariants;
  const isEvenNameLength = nonCustomerName.length % 2 === 0;
  const finalAvatarIndex = isEvenNameLength || avatarIndex === 0 ? avatarIndex + 1 : avatarIndex;
  return `https://cdn-imgix.headout.com/reviews/avatars/Avatar_${finalAvatarIndex}.svg`;
}, "getRandomReviewerImage");
var getCountryFlagUrl = /* @__PURE__ */ __name((countryCode) => FLAGS_FOLDER_URL + "/" + (countryCode == null ? void 0 : countryCode.toLowerCase()) + ".svg", "getCountryFlagUrl");
var getFirstName = /* @__PURE__ */ __name((fullName) => {
  if (!fullName) return "";
  const name = fullName.trim();
  if (name && name.includes(" ")) {
    return name.slice(0, name.indexOf(" "));
  }
  return name;
}, "getFirstName");
var getCapitalizedFirstName = /* @__PURE__ */ __name((nonCustomerName) => {
  return titleCase(
    (nonCustomerName != null ? nonCustomerName : "").toLowerCase().trim() === DEFAULT_REVIEWER_NAME ? nonCustomerName != null ? nonCustomerName : "" : getFirstName(nonCustomerName)
  );
}, "getCapitalizedFirstName");
var getStars = /* @__PURE__ */ __name((rating, size = 14, strokeColor = "colors.core.candy.500") => {
  const stars = [];
  for (let i = 0; i < Math.floor(rating); i++) {
    stars.push(
      StarFull_default({
        height: `${size}px`,
        width: `${size}px`,
        color: token3(strokeColor)
      })
    );
  }
  if (rating % 1 !== 0)
    stars.push(
      StarHalf_default({
        height: `${size}px`,
        width: `${size}px`,
        color: token3(strokeColor)
      })
    );
  for (let i = 0; i < 5 - Math.ceil(rating); i++) {
    stars.push(
      StarEmpty_default({
        height: `${size}px`,
        width: `${size}px`,
        color: token3(strokeColor)
      })
    );
  }
  return stars;
}, "getStars");
var parseReviewMedia = /* @__PURE__ */ __name(({
  media,
  id
}) => {
  return media.map((item, index) => __spreadProps(__spreadValues({}, item), {
    location: {
      localIndex: index,
      reviewId: id,
      globalIndex: -1
    },
    alt: `review-${id}-media-${index}`
  }));
}, "parseReviewMedia");

// src/components/ReviewsSection/components/ReviewCard/ReviewCard.tsx
import { useMemo, useRef, useState as useState2 } from "react";

// src/components/ReviewsSection/components/ReviewCard/styles.ts
import { css, sva } from "@headout/pixie/css";
var reviewMediaWrapper = css({
  width: "[5rem]",
  height: "[6.625rem]",
  marginRight: "space.8",
  overflow: "hidden",
  borderRadius: "radius.4",
  "& img": {
    cursor: "pointer",
    height: "100%"
  },
  _last: {
    marginRight: 0,
    position: "relative"
  }
});
var lastMediaSlideRecipe = sva({
  slots: ["root", "container", "text"],
  base: {
    root: {
      background: "linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6))",
      cursor: "pointer",
      width: "100%",
      height: "100%",
      overflow: "hidden",
      borderRadius: "radius.4",
      color: "core.primary.white",
      position: "absolute",
      top: 0,
      padding: "space.6"
    },
    container: {
      display: "flex",
      height: "100%",
      alignItems: "center",
      justifyContent: "center"
    },
    text: {
      textStyle: "ui.label.small",
      color: "core.primary.white",
      marginRight: "space.8"
    }
  }
});
var reviewCardWrapperRecipe = sva({
  slots: ["root"],
  base: {
    root: {
      position: "relative",
      margin: "[token(spacing.space.32) token(spacing.space.24) 0 0]",
      paddingTop: "space.12",
      border: "[1px solid token(colors.core.grey.300)]",
      borderRadius: "radius.8",
      backgroundColor: "core.primary.white",
      display: "flex",
      flexDirection: "column",
      height: "[23.5rem]",
      overflow: "hidden",
      "@media (max-width: 768px)": {
        minWidth: "[17.625rem]",
        margin: "[token(spacing.space.24) 0 0]",
        wordBreak: "break-word"
      }
    }
  },
  variants: {
    variant: {
      [EReviewsSectionVariants.PinnedReviews]: {
        root: {
          height: "auto",
          maxHeight: "[12.25rem]",
          borderRadius: "radius.12",
          margin: "[token(spacing.space.2) token(spacing.space.12) token(spacing.space.6) token(spacing.space.2)]",
          boxShadow: "[0px -4px 0px 0px #E2E2E280 inset, 0px 2px 6px -2px #E2E2E2, 0px 0px 0px 1px #E2E2E2]",
          border: "none",
          transition: "transform .2s",
          cursor: "pointer",
          '&[data-is-clicked="true"]': {
            transform: "scale(0.95)"
          },
          "@media(max-width: 768px)": {
            maxHeight: "[12.3rem]",
            minWidth: "[calc(100dvw - 4rem)]",
            margin: "[token(spacing.space.1) 0 token(spacing.space.6)]"
          }
        }
      },
      [EReviewsSectionVariants.Default]: {},
      [EReviewsSectionVariants.Modal]: {
        root: {
          height: "auto",
          borderRadius: "radius.0",
          margin: 0,
          paddingTop: 0,
          border: "none",
          maxWidth: "[49.5rem]",
          "@media(max-width: 768px)": {
            padding: "[0 token(spacing.space.16) token(spacing.space.32)]",
            margin: "[token(spacing.space.8) 0 0]"
          }
        }
      }
    }
  },
  defaultVariants: {
    variant: EReviewsSectionVariants.Default
  }
});
var reviewHeaderRecipe = sva({
  slots: ["root", "reviewMetadata", "ratingContainer"],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      padding: "[0 token(spacing.space.12)]"
    },
    reviewMetadata: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    },
    ratingContainer: {
      margin: "[token(spacing.space.8) 0 token(spacing.space.12)]",
      height: "[1rem]",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "space.2"
    }
  },
  variants: {
    variant: {
      [EReviewsSectionVariants.PinnedReviews]: {
        ratingContainer: {
          margin: "[token(spacing.space.12) 0 0]"
        }
      },
      [EReviewsSectionVariants.Default]: {},
      [EReviewsSectionVariants.Modal]: {
        root: { padding: 0 },
        ratingContainer: {
          margin: "[token(spacing.space.12) 0 0]"
        }
      }
    }
  },
  defaultVariants: {
    variant: EReviewsSectionVariants.Default
  }
});
var reviewerImageContainerRecipe = sva({
  slots: ["root", "reviewerImage", "countryFlag"],
  base: {
    root: {
      gridArea: "image",
      marginRight: "space.6",
      width: "[2.25rem]",
      height: "[2.25rem]",
      position: "relative"
    },
    reviewerImage: {
      borderRadius: "radius.50p",
      margin: "0 auto"
    },
    countryFlag: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "radius.50p",
      overflow: "hidden",
      position: "absolute",
      border: "[1px solid token(colors.core.grey.300)]",
      right: "[-0.125rem]",
      bottom: "[-0.0313rem]",
      height: "[0.938rem]",
      width: "[0.938rem]",
      "& div": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }
  }
});
var reviewMetadataContainerRecipe = sva({
  slots: ["root", "reviewerName", "countryAndDateContainer"],
  base: {
    root: { display: "flex", flexDirection: "column" },
    reviewerName: {
      overflow: "hidden",
      width: "100%",
      textStyle: "heading.small",
      color: "core.grey.800",
      textOverflow: "ellipsis",
      wordWrap: "break-word",
      whiteSpace: "nowrap",
      gridArea: "name",
      marginBottom: 0,
      marginTop: 0,
      "@media (max-width: 768px)": { marginBottom: "space.2" }
    },
    countryAndDateContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      flexWrap: "wrap"
    }
  }
});
var countryAndDateRecipe = sva({
  slots: ["countryName", "separator", "reviewDate"],
  base: {
    countryName: {
      textStyle: "ui.label.small",
      color: "core.grey.700",
      position: "relative",
      lineClamp: 1,
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    separator: {
      height: "[0.1875rem]",
      width: "[0.1875rem]",
      borderRadius: "radius.50p",
      backgroundColor: "semantic.text.grey.3",
      margin: "[0 token(spacing.space.6)]"
    },
    reviewDate: {
      textStyle: "ui.label.small",
      color: "core.grey.700",
      "@media screen and (min-width: 768px)": {
        alignSelf: "center"
      }
    }
  }
});
var imageCarouselContainer = css({
  display: "flex",
  marginTop: "0",
  marginBottom: "0",
  padding: "[0 token(spacing.space.12)]"
});
var reviewContentRecipe = sva({
  slots: ["root", "mainContent", "translateText", "readMoreLink"],
  base: {
    root: {
      display: "inline-block",
      flex: 1,
      wordBreak: "break-word",
      hyphens: "auto",
      marginTop: "0",
      padding: "[0 token(spacing.space.12)]"
    },
    mainContent: {
      textStyle: "para.regular",
      overflow: "hidden",
      textOverflow: "ellipsis",
      "@media (max-width: 768px)": {
        lineHeight: "[1.25rem]",
        fontSize: "[0.875rem]"
      }
    },
    translateText: {
      marginTop: "space.6",
      minHeight: "[1.25rem]"
    },
    readMoreLink: {
      marginTop: "space.4"
    }
  },
  variants: {
    hasMedia: {
      true: {
        root: {
          marginTop: "space.6",
          marginBottom: "space.12"
        }
      }
    },
    contentLimit: {
      4: { mainContent: { lineClamp: 4 } },
      5: { mainContent: { lineClamp: 5 } },
      10: { mainContent: { lineClamp: 10 } },
      11: { mainContent: { lineClamp: 11 } }
    },
    variant: {
      [EReviewsSectionVariants.PinnedReviews]: {
        root: { marginTop: "space.8" },
        readMoreLink: {
          margin: "[token(spacing.space.4) 0 token(spacing.space.12)]"
        }
      },
      [EReviewsSectionVariants.Default]: {},
      [EReviewsSectionVariants.Modal]: {
        root: { marginTop: "space.8", padding: 0 }
      }
    }
  },
  defaultVariants: {
    variant: EReviewsSectionVariants.Default
  }
});
var ctaContainerRecipe = sva({
  slots: ["root", "ctaText", "icon"],
  base: {
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "core.grey.100",
      padding: "0 token(spacing.space.12)",
      borderTop: "[1px solid token(colors.core.grey.300)]",
      height: "[3.5rem]"
    },
    ctaText: {
      textStyle: "ui.label.small.heavy",
      color: "core.grey.800",
      lineClamp: 2,
      overflow: "hidden",
      maxWidth: "70%",
      textAlign: "left"
    },
    icon: {
      transform: "rotate(0deg)",
      transition: "transform 0.3s cubic-bezier(0.3, 0, 0.7, 1)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      _groupHover: {
        transform: "rotate(-45deg)"
      }
    }
  },
  variants: {
    isClickable: {
      true: {
        root: { cursor: "pointer" },
        ctaText: { cursor: "pointer" }
      }
    }
  }
});
var modalContentClassName = css({
  "@media(max-width: 768px)": {
    padding: "0 token(spacing.space.12)"
  }
});

// src/components/ReviewsSection/components/ReviewCard/ReviewCard.tsx
import { cx } from "@headout/pixie/css";

// src/components/ReviewsSection/components/ReviewCard/hooks/useReviewCard.tsx
import { useEffect, useState } from "react";
var useReviewCard = /* @__PURE__ */ __name(({
  id,
  reviewMedias = [],
  tourGroup,
  useTranslatedContent,
  translatedContent,
  content,
  reviewTime,
  onImageClick,
  sourceLanguage,
  currentLanguage = "en",
  shouldFocusProductCardOnCTAClick = false,
  onCTAClick,
  strings,
  rating,
  trackingContext
}) => {
  const [reviewContent, setReviewContent] = useState(
    useTranslatedContent ? translatedContent : content
  );
  const [isProductCardPresent, setIsProductCardPresent] = useState(false);
  const reviewTimeFormatted = getIntlDate({
    date: reviewTime,
    lang: currentLanguage,
    dateFormat: "MMM-YYYY"
  });
  const isSupportedLanguage = sourceLanguage && LANGUAGE_SORT_ORDER.includes(sourceLanguage.toLowerCase());
  let finalReviewMedia = reviewMedias;
  const MAX_IMAGES_TO_BE_DISPLAYED = 3;
  const balanceImages = finalReviewMedia.length - MAX_IMAGES_TO_BE_DISPLAYED;
  if (reviewMedias.length > MAX_IMAGES_TO_BE_DISPLAYED) {
    finalReviewMedia = reviewMedias.slice(0, MAX_IMAGES_TO_BE_DISPLAYED);
  }
  const toggleReviewContent = /* @__PURE__ */ __name(() => {
    const shouldTranslate = reviewContent === content;
    const action = shouldTranslate ? REVIEW_CONTENT_ACTIONS.TRANSLATE_REVIEW : REVIEW_CONTENT_ACTIONS.VIEW_ORIGINAL;
    const finalContent = shouldTranslate ? translatedContent : content;
    setReviewContent(finalContent);
    trackingContext == null ? void 0 : trackingContext.onToggleReviewContent({ Action: action });
  }, "toggleReviewContent");
  const onMediaClick = /* @__PURE__ */ __name((index) => {
    onImageClick == null ? void 0 : onImageClick({
      mediaIndex: index,
      reviewId: id,
      reviewMedia: parseReviewMedia({ media: reviewMedias, id })
    });
  }, "onMediaClick");
  const handleBottomCTAClick = /* @__PURE__ */ __name(() => {
    if (isProductCardPresent && shouldFocusProductCardOnCTAClick) {
      onCTAClick == null ? void 0 : onCTAClick({
        tgid: tourGroup == null ? void 0 : tourGroup.id,
        rating,
        isProductCardPresent
      });
    } else if (!shouldFocusProductCardOnCTAClick) {
      onCTAClick == null ? void 0 : onCTAClick({
        tgid: tourGroup == null ? void 0 : tourGroup.id,
        rating,
        isProductCardPresent: false
      });
    }
  }, "handleBottomCTAClick");
  const getLanguageToDisplay = /* @__PURE__ */ __name((lang) => {
    var _a;
    return (_a = strings.REVIEW_LOC.LANGUAGES[lang.toUpperCase()]) != null ? _a : strings.REVIEW_LOC.LANGUAGES.EN;
  }, "getLanguageToDisplay");
  const getReviewContent = /* @__PURE__ */ __name(() => {
    switch (true) {
      case reviewContent === content:
        return strings.formatString(
          strings.REVIEW_LOC.TRANSLATE,
          getLanguageToDisplay(currentLanguage)
        );
      case isSupportedLanguage:
        return strings.formatString(
          strings.REVIEW_LOC.VIEW_ORIGINAL,
          getLanguageToDisplay(sourceLanguage)
        );
      default:
        return strings.REVIEW_LOC.VIEW_ORIGINAL_NO_LANG;
    }
  }, "getReviewContent");
  useEffect(() => {
    const checkProductCard = /* @__PURE__ */ __name(() => {
      const productCard = document.querySelector(
        `[data-tgid="${tourGroup == null ? void 0 : tourGroup.id}"]`
      );
      setIsProductCardPresent(!!productCard);
    }, "checkProductCard");
    checkProductCard();
    document.addEventListener("productCardsLoaded", checkProductCard);
    return () => {
      document.removeEventListener("productCardLoaded", checkProductCard);
    };
  }, [tourGroup == null ? void 0 : tourGroup.id]);
  return {
    reviewContent,
    toggleReviewContent,
    onMediaClick,
    handleBottomCTAClick,
    reviewTimeFormatted,
    finalReviewMedia,
    balanceImages,
    isProductCardPresent,
    getReviewContent
  };
}, "useReviewCard");

// src/components/ReviewsSection/components/ReviewCard/ReviewCard.tsx
import { Link, Text } from "@headout/eevee";
import { ChevronRight } from "@headout/onix/web/ui/chevron/stroke/index";
import dynamic from "next/dynamic.js";
var DynamicReviewCardOverlays = dynamic(
  () => import(
    /* webpackChunkName: "review-card-overlays" */
    "./ReviewCardOverlays-ZEUCX27I.jsx"
  ).then((mod) => mod.ReviewCardOverlays),
  { ssr: false }
);
var ReviewCard = /* @__PURE__ */ __name((props) => {
  const {
    nonCustomerName,
    rating,
    reviewerImageUrl,
    reviewMedias = [],
    nonCustomerCountryCode,
    nonCustomerCountryName,
    useTranslatedContent,
    tourGroup,
    shouldFocusProductCardOnCTAClick = true,
    onCTAClick,
    strings,
    variant = EReviewsSectionVariants.Default,
    isMobile = false,
    trackingContext,
    source,
    ranking
  } = props;
  const reviewContentRef = useRef(null);
  const modalControlRef = useRef(null);
  const [isSwipesheetOpen, setIsSwipesheetOpen] = useState2(false);
  const [isCardClicked, setIsCardClicked] = useState2(false);
  const {
    reviewContent,
    toggleReviewContent,
    onMediaClick,
    handleBottomCTAClick,
    reviewTimeFormatted,
    finalReviewMedia,
    balanceImages,
    isProductCardPresent,
    getReviewContent
  } = useReviewCard(props);
  const hasMedia = (reviewMedias == null ? void 0 : reviewMedias.length) > 0;
  const isReviewClickable = shouldFocusProductCardOnCTAClick && isProductCardPresent && !!onCTAClick;
  const reviewCardWrapperStyles = reviewCardWrapperRecipe({
    variant
  });
  const lastMediaStyles = lastMediaSlideRecipe();
  const reviewHeaderStyles = reviewHeaderRecipe({ variant });
  const reviewerImageContainerStyles = reviewerImageContainerRecipe();
  const reviewMetadataStyles = reviewMetadataContainerRecipe();
  const countryAndDateStyles = countryAndDateRecipe();
  const reviewContentStyles = reviewContentRecipe({
    hasMedia,
    contentLimit: getContentLimit({
      limitLines: hasMedia,
      hasTranslation: useTranslatedContent,
      variant
    }),
    variant
  });
  const ctaContainerStyles = ctaContainerRecipe({
    isClickable: isReviewClickable
  });
  const isPinnedReview = variant === EReviewsSectionVariants.PinnedReviews;
  const isModal = variant === EReviewsSectionVariants.Modal;
  const onReviewCardClick = /* @__PURE__ */ __name(() => {
    if (isPinnedReview) {
      setTimeout(() => {
        var _a, _b, _c, _d;
        (_a = trackingContext == null ? void 0 : trackingContext.onCardClick) == null ? void 0 : _a.call(trackingContext, {
          "Card Type": "Pinned Reviews Card",
          Rating: rating,
          Ranking: ranking
        });
        if (isMobile) {
          setIsSwipesheetOpen(true);
          (_b = trackingContext == null ? void 0 : trackingContext.onSwipeSheetOpen) == null ? void 0 : _b.call(trackingContext, {
            Rating: rating,
            Ranking: ranking
          });
        } else {
          (_c = modalControlRef.current) == null ? void 0 : _c.open();
          (_d = trackingContext == null ? void 0 : trackingContext.onModalOpen) == null ? void 0 : _d.call(trackingContext, {
            Rating: rating,
            Ranking: ranking
          });
        }
      }, 200);
    }
  }, "onReviewCardClick");
  const onMouseDown = /* @__PURE__ */ __name(() => {
    if (isPinnedReview) {
      setIsCardClicked(true);
    }
  }, "onMouseDown");
  const onMouseUp = /* @__PURE__ */ __name(() => {
    if (isPinnedReview) {
      setIsCardClicked(false);
    }
  }, "onMouseUp");
  const carouselItems = useMemo(
    () => finalReviewMedia == null ? void 0 : finalReviewMedia.map(({ url }, index) => <div
      className={reviewMediaWrapper}
      key={index}
      onClick={() => onMediaClick(index)}
      onKeyDown={(e) => onEnterKeyPress(e, onMediaClick, index)}
      role='button'
      tabIndex={0}
    >
					<Image
      width={80}
      height={106}
      url={url}
      alt='review-image'
    />

					<Conditional if={!!(index === 2 && balanceImages)}>
						<div className={lastMediaStyles.root}>
							<div className={lastMediaStyles.container}>
								<p className={lastMediaStyles.text}>
									+
									{strings.formatString(
      strings.X_MORE,
      balanceImages.toString()
    )}
								</p>
							</div>
						</div>
					</Conditional>
				</div>),
    [finalReviewMedia, onMediaClick, balanceImages]
  );
  const isPartner = source === "PARTNER";
  return <>
			<div
    className={reviewCardWrapperStyles.root}
    onClick={onReviewCardClick}
    onKeyDown={(e) => onEnterKeyPress(e, () => onReviewCardClick(), null)}
    role='button'
    tabIndex={0}
    data-is-clicked={isCardClicked}
    onMouseDown={onMouseDown}
    onMouseUp={onMouseUp}
    onTouchStart={onMouseDown}
    onTouchEnd={onMouseUp}
  >
				<div className={reviewHeaderStyles.root}>
					<div className={reviewHeaderStyles.reviewMetadata}>
						<div className={reviewerImageContainerStyles.root}>
							<Image
    className={reviewerImageContainerStyles.reviewerImage}
    alt={nonCustomerName}
    url={reviewerImageUrl != null ? reviewerImageUrl : getRandomReviewerImage(
      nonCustomerName || ""
    )}
    width={36}
    height={36}
  />
							<Conditional if={!!nonCustomerCountryCode}>
								<div
    className={reviewerImageContainerStyles.countryFlag}
  >
									<Image
    url={getCountryFlagUrl(
      nonCustomerCountryCode
    )}
    alt={nonCustomerCountryCode != null ? nonCustomerCountryCode : "country flag"}
    height={15}
    width={15}
  />
								</div>
							</Conditional>
						</div>
						<div className={reviewMetadataStyles.root}>
							<Text
    as='p'
    className={reviewMetadataStyles.reviewerName}
  >
								{getCapitalizedFirstName(nonCustomerName)}
							</Text>
							<div
    className={reviewMetadataStyles.countryAndDateContainer}
  >
								<Conditional if={!!nonCustomerCountryName}>
									<Text
    as='span'
    className={countryAndDateStyles.countryName}
  >
										{nonCustomerCountryName}
									</Text>
								</Conditional>
								<Conditional
    if={!!(reviewTimeFormatted && nonCustomerCountryName)}
  >
									<div
    className={countryAndDateStyles.separator}
  />
								</Conditional>
								<Text
    as='span'
    className={countryAndDateStyles.reviewDate}
  >
									{reviewTimeFormatted}
								</Text>
								<Conditional if={isPinnedReview || isModal}>
									<div
    className={countryAndDateStyles.separator}
  />
									<Text
    as='span'
    className={countryAndDateStyles.reviewDate}
  >
										{isPartner ? strings.REVIEWS_SECTION.VERIFIED_REVIEW : strings.REVIEWS_SECTION.TRUST_VB_TAG}
									</Text>
								</Conditional>
							</div>
						</div>
					</div>
					<div className={reviewHeaderStyles.ratingContainer}>
						{getStars(rating, 16)}
					</div>
				</div>
				<Conditional if={hasMedia}>
					<div className={imageCarouselContainer}>
						{carouselItems}
					</div>
				</Conditional>

				<Conditional if={!!reviewContent}>
					<div className={reviewContentStyles.root}>
						<div
    className={reviewContentStyles.mainContent}
    ref={reviewContentRef}
  >
							{reviewContent}
						</div>

						<Conditional
    if={useTranslatedContent && !isPinnedReview}
  >
							<Link
    as={"button"}
    text={getReviewContent()}
    size='regular'
    heavy
    onClick={toggleReviewContent}
    underline
    className={reviewContentStyles.translateText}
  />
						</Conditional>

						<Conditional if={isPinnedReview}>
							<Link
    text={strings.READ_MORE}
    size='regular'
    heavy
    as={"button"}
    underline={false}
    trailingIcon={<ChevronRight height={12} width={12} />}
    className={reviewContentStyles.readMoreLink}
  />
						</Conditional>
					</div>
				</Conditional>

				<Conditional if={!!tourGroup}>
					<button
    className={cx("group", ctaContainerStyles.root)}
    onClick={handleBottomCTAClick}
  >
						<div className={ctaContainerStyles.ctaText}>
							{tourGroup == null ? void 0 : tourGroup.urlText}
						</div>
						<Conditional if={isReviewClickable}>
							<div className={ctaContainerStyles.icon}>
								<TailedArrow_default
    strokeColor='colors.core.grey.800'
    strokeWidth='1'
  />
							</div>
						</Conditional>
					</button>
				</Conditional>
			</div>

			<Conditional if={isPinnedReview}>
				<DynamicReviewCardOverlays
    props={props}
    isSwipesheetOpen={isSwipesheetOpen}
    setIsSwipesheetOpen={setIsSwipesheetOpen}
    modalControlRef={modalControlRef}
  />
			</Conditional>
		</>;
}, "ReviewCard");

export {
  EReviewsSectionVariants,
  getRandomReviewerImage,
  getCapitalizedFirstName,
  getStars,
  ReviewCard
};
